export const TEMP_ID_PREFIX = 'tmp';